import React, {useEffect} from 'react';
import styles from "./MatchResult.module.scss";
import DefaultLayout from "../../layouts/DefaultLayout";
import Warning from "../../components/common/warning/Warning";
import {useDispatch, useSelector} from "react-redux";
import Button from "../../components/common/button/Button";
import {resetSearch} from "../../redux/actions";
import moment from "moment";
import loadingIcon from "../../assets/images/np_loading.png";

const MatchResult = props => {
  const dispatch = useDispatch();
  const matchData = useSelector(state => state.match);
  const personData = useSelector(state => state.person);
  const robotData = useSelector(state => state.robot);

  useEffect(() => {
    if(!robotData.notARobot) {
      props.history.push('/')
    }
  }, []);

  const {
    firstname, middlename, lastname,
    death, birth, nursingHome,
    certificateLongNum, certificateShortNum, currentAddress,deceasedState
  } = personData;
  const certificateNumber = !certificateLongNum || !certificateShortNum ? 'Not provided' : `${certificateLongNum}-${certificateShortNum}`;

  let address = "";
  if (currentAddress && currentAddress.lookupValue) {
    address = currentAddress.lookupValue.label;
  } else if (currentAddress && currentAddress.enterManually) {
    address = `${currentAddress.addressLine}, ${currentAddress.suburb} ${currentAddress.state ? currentAddress.state.label : ''} ${currentAddress.postcode}`;
  }


  return <DefaultLayout>
    {matchData.searching ?
      <div className={styles.loadingCont}>
        <img src={loadingIcon} alt={"loading"} className={styles.spinner}/>
        <div>Loading...</div>
      </div> :
      <div className={styles.mainCont}>
        <div>
          <div className={'row'}>
            <div className={'col-12'}>
              {matchData.result ?
                <h2>Record successfully matched</h2> :
                <h2>Record not found</h2>}
            </div>
          </div>
          {matchData.result ?
            <Warning
              type={'success'}
              description={`Record successfully matched.`}
            /> :
            <Warning
              type={'error'}
              description={`Unfortunately we couldn't verify the details of this person's death using the Australian Death Check.`}
            />
          }
          {matchData.result ?
            <div>
              <p>A record was successfully matched to the Australian Death Check. Please confirm the following details
                are
                correct:</p>
              <p>
                <em>
                  {`${firstname || ''} ${middlename || ''} ${lastname || ''}`}
                </em>
              </p>
              <p>
                <em>Date of Death: {death ? moment(death, "YYYY-MM-DD").format('D MMMM YYYY') : ''}</em><br/>
                <em>State/Territory where the person
                  died: {deceasedState}</em>
              </p>
              <p>
                These additional details will be passed onto ANZ also:
              </p>
              <p>
                <em>Date of Birth: {birth ? moment(birth, "YYYY-MM-DD").format('D MMMM YYYY') : ''}</em><br/>
                Address: <em>{address ? address : ''}</em> <br/>
                {nursingHome && nursingHome.value ? [<em>Nursing Home: {nursingHome.value}</em>, <br/>] : null}
                <em>Death Certificate Registration Number: {certificateNumber}</em>
              </p>
              <div className={`row ${styles.buttonCont}`}>
                <div className={`col-6`}>
                  <Button onClick={() => {
                    window.scrollTo(0, 0);
                    props.history.push('/your-details')
                  }}>Yes, these details are correct</Button>
                </div>
                <div className={'col-6'}>&nbsp;</div>
              </div>
            </div> :
            <div>
              <p>
                We couldn’t match a record using the details you provided. Please check that all the information you
                provided
                is
                correct and that a death certificate has been issued.
              </p>
              <p>
                <em>
                  {`${firstname || ''} ${middlename || ''} ${lastname || ''}`}
                </em>
              </p>
              <p>
                <em>
                  Date of Birth: {birth ? moment(birth, "YYYY-MM-DD").format('D MMMM YYYY') : ''}<br/>
                  Date of Death: {death ? moment(death, "YYYY-MM-DD").format('D MMMM YYYY') : ''}<br/>
                  State/Territory where the person
                  died: {deceasedState}<br/>
                  Last known address: {address ? address : ''}<br/>
                  Death Certificate Registration Number: {certificateNumber}
                </em>
              </p>
              {/* <Button secondary
                      className={styles.spacedBelow}
                      onClick={() => {
                dispatch(resetSearch());
                window.scrollTo(0, 0);
                props.history.push('/welcome')
              }}>Search again</Button> */}
              <p>
              You can still notify the ANZ Estates Team on 1800 237 170 from 8.00am and 5:30pm (AEST) Monday to Friday excluding public holidays.
              </p>
              <p>
                Alternatively, you can visit an ANZ branch to speak to someone in person.
              </p>
              <Button secondary
                      className={styles.spacedBelow}
                      onClick={() =>window.open("https://www.anz.com.au/locations/")}>Find an ANZ Branch</Button>
              {/* <p>Here is a list of documents that ANZ may need in order to settle savings and transaction accounts and
                release
                Estate funds for someone who has died.</p>
              <a href={'#'}>Deceased estates document checklist</a> */}
              <div className={styles.btnCont}>
                <Button secondary onClick={() => {
                  window.scrollTo(0, 0);
                  props.history.push('/deceased-details')
                }}>Search again</Button>
              </div>
            </div>}
        </div>
      </div>}
  </DefaultLayout>
};

export default MatchResult;
